import React from 'react';
import ClipLoader from 'react-spinners/ClipLoader';
import styled from 'styled-components';
import favoriteIcon from '../img/sprite/track-favorite.svg';

const StyledLink = styled.a`
  cursor: pointer;
`;
const StyledLoader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
`;

const FavoriteBtn = ({ isFavorite = false, onClick, isLoading }) => {
	return (
		<StyledLink
			className={`player__interaction-button waves-effect waves-button ${isFavorite ? 'is-active' : ''}`}
			onClick={onClick}
		>
			{
				isLoading
					? (
						<StyledLoader>
							<ClipLoader color="#10DB92" size={18}/>
						</StyledLoader>
					)
					: <img src={favoriteIcon} alt="" width={24} height={24}/>
			}
		</StyledLink>
	);
};

export default FavoriteBtn;
